<div (keydown)="handleKeydown($event)" class="model-cover" [ngClass]="modalCoverClass" *ngIf="showModal">
  {{loadFocusTelements()}}
  <div class="model-box" [ngClass]="modalClass">
    <ng-content></ng-content>
  </div>
</div>
<!-- <div class="model-cover" *ngIf="showModal">
  <div *ngIf="showModal">{{loadFocustelements()}}</div>
  <div class="model-box text-left" (keydown)="handleKeydown($event)">
    <div *ngIf="modalHeader ?.length > 0">
      <h2> {{modalHeader}} </h2>
    </div>
    <div class="corner-button">
      <button class="close" aria-label="Close" (click)="btnAction('no')">x</button>
    </div>
    <div *ngIf="modalSubHeader ?.length > 0">
      <h3> {{modalSubHeader}} </h3>
    </div>
    <br/>
    <p>{{modalMessage}}</p>
    <hr/>
    <div class="form-group">
      <div class="col-md-12 text-right">
        <a href="javascript:void(0)" class="btn btn-link" (click)="btnAction('no')">Cancel</a>
        <a href="javascript:void(0)" class="btn btn-secondary" (click)="btnAction('yes')">Ok</a>
      </div>
    </div>
  </div>
</div> -->